import { render, staticRenderFns } from "./chatDataListRe.vue?vue&type=template&id=1e00c7d1&scoped=true&"
import script from "./chatDataListRe.vue?vue&type=script&lang=js&"
export * from "./chatDataListRe.vue?vue&type=script&lang=js&"
import style0 from "./chatDataListRe.vue?vue&type=style&index=0&id=1e00c7d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e00c7d1",
  null
  
)

export default component.exports